<!-- Quota Information Message -->
@if (!recordDetails.assigned_to && recordDetails.lead_quota) {
  <div class="quota-info-wrapper property-group-section" id="tour-lead-info">
    <div class="section-header">
      <h4>Lead Quota Status</h4>
    </div>
    <div class="quota-content">
      @if (
        recordDetails.lead_quota.lead_count >= recordDetails.lead_quota.quota
      ) {
        <div
          class="quota-message quota-exceeded"
          [class.quota-highlight]="isAssignButtonHovered && isQuotaExceeded()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            class="quota-icon"
          >
            <path
              d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
            />
          </svg>
          <div class="quota-text">
            <span class="quota-title">Lead Quota Exceeded</span>
            <span class="quota-details"
              >You have reached your lead quota limit ({{
                recordDetails.lead_quota.lead_count
              }}/{{ recordDetails.lead_quota.quota }} leads assigned)</span
            >
          </div>
        </div>
      } @else {
        <div class="quota-message quota-available">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            class="quota-icon"
          >
            <path
              d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
            />
          </svg>
          <div class="quota-text">
            <span class="quota-title">Quota Available</span>
            <span class="quota-details"
              >You have {{ recordDetails.lead_quota.lead_count }}/{{
                recordDetails.lead_quota.quota
              }}
              leads assigned</span
            >
            <div class="quota-progress">
              <div class="quota-progress-bar">
                <div
                  class="quota-progress-fill"
                  [style.width]="
                    (recordDetails.lead_quota.lead_count /
                      recordDetails.lead_quota.quota) *
                      100 +
                    '%'
                  "
                ></div>
              </div>
              <span class="quota-percentage"
                >{{
                  (
                    (recordDetails.lead_quota.lead_count /
                      recordDetails.lead_quota.quota) *
                    100
                  ).toFixed(0)
                }}%</span
              >
            </div>
          </div>
        </div>
      }
    </div>
  </div>
}
